// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-component__curveBorderTop___2fQrk {\n  border-top: 1px dashed transparent;\n  border-top-right-radius: 90px;\n  background-color: #fff;\n  position: absolute;\n}\n", ""]);
// Exports
exports.locals = {
	"curveBorderTop": "home-component__curveBorderTop___2fQrk"
};
module.exports = exports;
